import axios from 'axios';

const trimTrailingSlashes = (value = '') => value.replace(/\/+$/, '');
const ensureLeadingSlash = (value = '') => (value.startsWith('/') ? value : `/${value}`);

const rawEnvOrigin = (process.env.REACT_APP_API_URL || '').trim();
const fallbackOrigin = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const resolvedOrigin = rawEnvOrigin || fallbackOrigin;

if (!resolvedOrigin) {
  throw new Error('REACT_APP_API_URL must be defined for production builds.');
}

const apiOrigin = trimTrailingSlashes(resolvedOrigin);
const API_PATH_PREFIX = '/api';

const normalizeApiPath = (path = '') => {
  const safePath = (path || '').trim();
  if (!safePath) {
    return API_PATH_PREFIX;
  }
  const withLeadingSlash = ensureLeadingSlash(safePath);
  if (
    withLeadingSlash === API_PATH_PREFIX ||
    withLeadingSlash.startsWith(`${API_PATH_PREFIX}/`)
  ) {
    return withLeadingSlash;
  }
  return `${API_PATH_PREFIX}${withLeadingSlash}`;
};

const API_BASE_URL = `${apiOrigin}${API_PATH_PREFIX}`;

export const getApiBaseUrl = () => API_BASE_URL;

export const buildApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }
  return `${apiOrigin}${normalizeApiPath(path)}`;
};

export const withApiPath = (path = '') => normalizeApiPath(path);

export const getStoredToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return sessionStorage.getItem('token') || localStorage.getItem('token');
};

export const getAuthHeaders = (token) => {
  const authToken = token || getStoredToken();
  if (!authToken) {
    throw new Error('Authentication token is missing.');
  }
  return { Authorization: `Bearer ${authToken}` };
};

const apiClient = axios.create({
  baseURL: apiOrigin,
});

apiClient.interceptors.request.use((config) => {
  const token = getStoredToken();

  if (token && !(config.headers || {}).Authorization) {
    config.headers = {
      ...(config.headers || {}),
      ...getAuthHeaders(token),
    };
  }

  return config;
});

export default apiClient;
